var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkedinFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4933 17.591H25.778V21.2197C26.8274 19.1327 29.5185 17.2576 33.561 17.2576C41.3105 17.2576 43.1504 21.4119 43.1504 29.034V43.1504H35.3047V30.7699C35.3047 26.4292 34.2553 23.9814 31.5838 23.9814C27.8787 23.9814 26.339 26.6195 26.339 30.7679V43.1504H18.4933V17.591ZM5.03989 42.8169H12.8856V17.2576H5.03989V42.8169ZM14.0095 8.92351C14.0098 9.58113 13.8794 10.2322 13.6258 10.839C13.3723 11.4458 13.0006 11.9961 12.5325 12.458C12.063 12.925 11.5061 13.295 10.8936 13.5467C10.2811 13.7985 9.62497 13.9271 8.96274 13.9251C7.62819 13.9221 6.34799 13.3961 5.39687 12.46C4.93064 11.9964 4.56038 11.4454 4.30729 10.8386C4.05419 10.2318 3.92322 9.58099 3.92188 8.92351C3.92188 7.59563 4.45146 6.32462 5.39883 5.38706C6.34757 4.44731 7.62931 3.92065 8.9647 3.92188C10.3024 3.92188 11.5852 4.4495 12.5325 5.38706C13.4799 6.32462 14.0095 7.59563 14.0095 8.92351Z",
    fill: "#2783EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedinFill);
export default __webpack_public_path__ + "static/media/icon-linkedin-fill.f3ac47a234ea41cc9a9e5310f5e82984.svg";
export { ForwardRef as ReactComponent };